import axios from 'axios';

const invoicingServiceApi = axios.create({
  baseURL: process.env.INVOICING_SERVICE_URI,
});

export default invoicingServiceApi;

export const getInvoiceReport = (invoiceId: string | undefined) =>
  invoicingServiceApi
    .get<Blob>(`/opstools/v1/invoices/${invoiceId}/pdf`, {
      responseType: 'arraybuffer',
    })
    .then(response => response);

export const getPaymentDocumentPdfLink = (paymentDocumentId: string | undefined) =>
  invoicingServiceApi
    .get<{ url: string }>(`/opstools/v1/paymentdocuments/${paymentDocumentId}/pdf`)
    .then(response => response.data);

export const getProductSalesInvoice = (invoiceId?: string) =>
  invoicingServiceApi
    .get<Blob>(`/opstools/v1/invoices/${invoiceId}/pdf`, { responseType: 'arraybuffer' })
    .then(response => response);
